import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-tb-icon',
  templateUrl: './tb-icon.component.html',
  styleUrls: ['./tb-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TbIconComponent implements OnInit {
  public _icon: string;
  @Input() set icon(icon: string) {
    this._icon = icon;
    this.isLogo = this.isLogoImage();
    this.isSvg = this.isSvgIcon();
    this.isImgDisabled = this.isSvgIcon();
  }
  @Input() isImage: boolean;
  @Input() color: string;
  public isSvg: boolean;
  public isLogo: boolean;
  public isLogoDisabled: boolean;
  public isImgDisabled: boolean;
  public logoType: string;
  public modifyColor: any;
  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.color && this.color.includes('var')) {
      this.modifyColor = this.sanitizer.bypassSecurityTrustStyle(this.color);
    } else {
      this.modifyColor = this.color;
    }
  }

  public isSvgIcon(): boolean {
    // Names in the 'tb' namespace come from our own sprite; anything else is a Material ligature.
    if (this._icon && this._icon.indexOf('tb:') === 0) {
      return true;
    }
    return false;
  }

  public isLogoImage(): boolean {
    if (this._icon && this._icon.indexOf('logo-') === 0) {
      if (this._icon.endsWith('&disabled')) {
        this.isLogoDisabled = true;
        this._icon = this._icon.split('&')[0];
      }
      this.logoType = this._icon.split('-')[1];
      return true;
    }
    return false;
  }
}
